import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Footer from '../components/Footer/Footer'
import ProjectDetail from './ProjectDetail'

const Projectdetailspage = () => {
  return (
    <div>
        <Navbar/>

        <ProjectDetail/>




        <Footer/>
    </div>
  )
}

export default Projectdetailspage
